import React from 'react';
import { useSelector } from 'react-redux';
import Rule from './rule';
import BaseContainer from '../../baseContainer';
import Title from '../../baseComponents/Title';
import { getNeededTokensToRoll } from '../../../redux/Rules/selectors';

const RulesContainer = () => {
  const {
    game: { players, controlledPlayer, tokens },
  } = useSelector((state) => state);
  const { rules } = players[controlledPlayer];
  const rollCost = useSelector((state) => getNeededTokensToRoll(state));

  const Rules = rules.map((rule) => {
    return <Rule key={rule.id} canRoll={rollCost <= tokens} rule={rule} />;
  });

  return (
    <BaseContainer flexDirection="column">
      <Title text="Rules" />
      {Rules}
    </BaseContainer>
  );
};

export default RulesContainer;
